export type ColumnMappingType = {
  [key: string]: string;
};

export const normalizeColumnType = (columnType: string) => {
  const columnTypeMapping: ColumnMappingType = {
    color: "status",
    numeric: "numbers",
    boolean: "checkbox",
    timerange: "timeline",
    "long-text": "long_text",
    "multiple-person": "people",
    "board-relation": "board_relation",
    tag: "tags",
  };
  return columnTypeMapping[columnType] || columnType;
};
